// Validation utilities for Student Portal

/**
 * Validate email format
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validate phone number (10 digits)
 */
export const isValidPhoneNumber = (phone) => {
  if (!phone) return true; // Optional field
  const phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phone);
};

/**
 * Validate year (4 digits)
 */
export const isValidYear = (year) => {
  if (!year) return true; // Optional field
  const yearRegex = /^\d{4}$/;
  const numYear = parseInt(year, 10);
  const currentYear = new Date().getFullYear();
  return yearRegex.test(year) && numYear >= 1900 && numYear <= currentYear + 10;
};

/**
 * Validate activity title
 */
export const isValidActivityTitle = (title) => {
  return title && title.trim().length > 0 && title.trim().length <= 200;
};

/**
 * Validate activity date
 */
export const isValidActivityDate = (date) => {
  if (!date) return false;
  const activityDate = new Date(date);
  const today = new Date();
  today.setHours(23, 59, 59, 999); // End of today
  return activityDate <= today;
};

/**
 * Validate certification name
 */
export const isValidCertificationName = (name) => {
  return name && name.trim().length > 0 && name.trim().length <= 100;
};

/**
 * Validate image file type
 */
export const isValidImageFile = (file) => {
  if (!file) return false;
  return file.type.startsWith("image/");
};

/**
 * Validate image file size (max 5MB before compression)
 */
export const isValidImageSize = (file, maxSizeMB = 5) => {
  if (!file) return false;
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size <= maxSizeBytes;
};

/**
 * Get validation error message
 */
export const getValidationError = (field, value) => {
  switch (field) {
    case "title":
      if (!value || value.trim().length === 0) return "Title is required";
      if (value.trim().length > 200)
        return "Title must be 200 characters or less";
      return null;

    case "date":
      if (!value) return "Date is required";
      if (!isValidActivityDate(value)) return "Date cannot be in the future";
      return null;

    case "type":
      if (!value || value.trim().length === 0)
        return "Activity type is required";
      return null;

    case "email":
      if (!value) return "Email is required";
      if (!isValidEmail(value)) return "Invalid email format";
      return null;

    case "phoneNumber":
      if (value && !isValidPhoneNumber(value))
        return "Phone number must be 10 digits";
      return null;

    case "yearOfJoining":
      if (value && !isValidYear(value)) return "Invalid year format";
      return null;

    default:
      return null;
  }
};
